import { Provider } from '@angular/core';
import {
  RouteReuseStrategy,
  withComponentInputBinding,
  withInMemoryScrolling,
  withPreloading,
  withRouterConfig,
} from '@angular/router';
import { CachedReuseStrategy } from './cached-reuse.strategy';
import { SmartPreloadStrategy } from './smart-preload.strategy';

/**
 * Features del router para `provideRouter(APP_ROUTES, ...routerFeatures)`.
 * - withComponentInputBinding: enlaza path params a inputs (usar en DETALLES;
 *   los listados reutilizables leen query con toSignal(queryParamMap)).
 * - withInMemoryScrolling: restaura el scroll del documento en back/forward.
 * - withRouterConfig paramsInheritanceStrategy 'always': los hijos heredan los
 *   params del padre (ej. :group en rutas anidadas).
 * - withPreloading: precarga selectiva (data.preload).
 */
export const routerFeatures = [
  withComponentInputBinding(),
  withInMemoryScrolling({
    scrollPositionRestoration: 'enabled',
    anchorScrolling: 'enabled',
  }),
  withRouterConfig({ paramsInheritanceStrategy: 'always' }),
  withPreloading(SmartPreloadStrategy),
];

export const routerProviders: Provider[] = [
  { provide: RouteReuseStrategy, useClass: CachedReuseStrategy },
];
